import { Breadcrumb } from 'react-breadcrumbs';
import { Helmet } from 'react-helmet-async';

import CalendarEventTemplateCreateForm from './CalendarEventTemplateCreateForm';
import Flash from '../../../library/utils/Flash';
import LoadingSpinner from '../../../library/utils/LoadingSpinner';
import Section from '../../../library/layout/Section';
import useQueryState from '../../../../hooks/use-query-state';
import { useCalendarEventTemplate } from '../../../../hooks/queries/calendar-event-templates';
import { correctPath } from 'libraries/gem';

const CalendarEventTemplateCreate = () => {
  const [baseId] = useQueryState<string>('base', '');
  const {
    error: baseTemplateError,
    isLoading: isBaseTemplateLoading,
  } = useCalendarEventTemplate(baseId);

  if (baseId && isBaseTemplateLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Breadcrumb
      data={{
        title: 'Create',
        pathname: correctPath('/app/calendar-event-templates/create'),
      }}
    >
      <Section
        className="calendar-event-template-create-container"
        title="Create a new calendar event template"
      >
        <Helmet>
          <title>Create Calendar Event Template | Gem Scheduling</title>
        </Helmet>
        <div className="calendar-event-template-create-steps-container">
          {baseTemplateError ? (
            <Flash
              message={baseTemplateError?.message}
              showFlash={Boolean(baseTemplateError)}
              type="danger"
            />
          ) : (
            <CalendarEventTemplateCreateForm />
          )}
        </div>
      </Section>
    </Breadcrumb>
  );
};

export default CalendarEventTemplateCreate;
